<div class="privacy-policy-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Privacy Policy - Thorough Repository Pty Ltd
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closePopup()"
    ></button>
  </div>

  <div class="modal-body">
    <div
      name="termly-embed"
      data-id="e7c9ef2b-cc51-4ed1-9063-566bbb7ef11d"
    ></div>
  </div>
</div>
